import { createConsiliApi, addConsiliApi, baseApi } from './createApi';
export const getInsightsAPI = createConsiliApi(
  'getInsights',
  '/discovery/insight/',
  'GET',
  ['Insight']
);
export const { useGetInsightsQuery } = getInsightsAPI;

export const getInsightsByPageAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInsightsByPage: builder.query({
      query: (page = 1) => `/discovery/insight/?page=${page}`,
      providesTags: ['Insight'],
    }),
  }),
  overrideExisting: false,
});
export const { useGetInsightsByPageQuery } = getInsightsByPageAPI;

export const getInterestsApi = createConsiliApi(
  'getInterests',
  '/discovery/interest/',
  'GET',
  ['Interest']
);
export const { useGetInterestsQuery } = getInterestsApi;

export const createInterestApi = addConsiliApi(
  'createInterest',
  (data) => `/discovery/interest/${data.id}/`,
  'POST',
  ['Interest']
);
export const { useCreateInterestMutation } = createInterestApi;

export const updateInterestApi = addConsiliApi(
  'updateInterest',
  (data) => `/discovery/interest/${data.id}/`,
  'PATCH',
  ['Interest']
);
export const { useUpdateInterestMutation } = updateInterestApi;

export const deleteInterestApi = addConsiliApi(
  'deleteInterest',
  (data) => `/discovery/interest/${data.id}/`,
  'DELETE',
  ['Interest']
);
export const { useDeleteInterestMutation } = deleteInterestApi;

export const categoriesApi = createConsiliApi(
  'getCategories',
  '/discovery/category/',
  'GET',
  ['Interest']
);
export const { useGetCategoriesQuery } = categoriesApi;

export const createCategoriesApi = addConsiliApi(
  'createCategory',
  (data) => `/discovery/category/${data.id}/`,
  'POST',
  ['Category']
);
export const { useCreateCategoryMutation } = createCategoriesApi;

export const sourcesApi = createConsiliApi(
  'getSources',
  '/discovery/source/',
  'GET',
  ['Source']
);
export const { useGetSourcesQuery } = sourcesApi;

export const createChatApi = addConsiliApi(
  'createChat',
  () => `/discovery/chat/initialize_chat/`,
  'POST',
  ['Chat']
);

export const { useCreateChatMutation } = createChatApi;

export const addMessageToChatApi = addConsiliApi(
  'addMessageToChat',
  (data) => `/discovery/chat/${data.thread_id}/add_message/`,
  'POST',
  ['Chat']
);

export const { useAddMessageToChatMutation } = addMessageToChatApi;
